import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { useFormik } from "formik";
import * as Yup from "yup";

import { toast } from "react-toastify";

import Contactame from "../images/contacto.png"

import {AiFillLinkedin} from 'react-icons/ai'



const MENSAJE = gql`
  mutation Mutation($input: InputMensaje) {
    crearMensaje(input: $input) {
      mensaje
    }
  }
`;

const Contactarme = () => {
  const [mensaje, guardarMensaje] = useState(null);

  const [crearMensaje] = useMutation(MENSAJE);

  const mostrarMensaje = () => {
    return (
      <div className=" px-3 w-full text-gray-200 py-10 font-bold text-2xl max-w-sm text-center mx-auto">
        <p>{mensaje}</p>
      </div>
    );
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
      mensaje: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("The email is not valid")
        .required("Mail must not be empty"),
      name: Yup.string().required("The name is required"),
      mensaje: Yup.string().required("The message is required"),
    }),
    onSubmit: async (valores,{resetForm}) => {
      const { email, name, mensaje } = valores;
      try {
        const { data } = await crearMensaje({
          variables: {
            input: {
              email,
              name,
              mensaje,
            },
          },
        });
        console.log(data);
        toast.success("Mensaje enviado con exito");
        resetForm({})
      } catch (error) {
        guardarMensaje(error.message.replace("GraphQL error: ", ""));
      }
    },
  });

  return (
    <div id="contactame" className="md:h-screen h-full bg-gray-800">
      {mensaje && mostrarMensaje()}
      <h1 className="text-center pt-2 sm:text-4xl text-2xl  md:text-6xl text-emerald-300 font-light">
      Contact
      </h1>
      <h4 className="text-gray-300 text-center font-semibold sm:text-lg text-base  md:text-xl mt-4">
      I am currently looking for new opportunities. Whether you have a
         question or just want to say hello, it will be a pleasure to answer you
      </h4>
       
      <div className="md:flex h-3/4 mt-10 ">
        <div className="md:w-1/2 lg:flex hidden ">
            <img alt="Imagen contacto" className="rounded-xl " src={Contactame}/>
        </div>
           
          <div className="w-full flex justify-content  items-center w-full lg:w-1/2">
            
            <div className="w-full">
               <div className=" flex justify-center mb-4">
                  <h4  
                  className="text-center flex w-6/12 sm:w-4/12 text-gray-200 rounded-xl sm:text-xl text-xl lg:text-3xl font-bold py-2 px-8 bg-emerald-500"
                  > <AiFillLinkedin className="md:text-4xl md:mt-0 mt-1 text-xl"/>
                    <a target='_blank' className="" href="https://www.linkedin.com/in/yeremi-araya-urbina-242a7321a/"> Linkedin</a></h4>
              </div>
              
          
            <form
              className="bg-white w-2/3 m-auto rounded shadow-md px-8 pt-8 pb-8 mb-4"
              onSubmit={formik.handleSubmit}
            >
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  Name
                </label>

                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="name"
                  type="text"
                  placeholder="Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                />
              </div>
              {formik.touched.name && formik.errors.name ? (
                <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4">
                  <p className="font-bold">Error</p>
                  <p>{formik.errors.name}</p>
                </div>
              ) : null}

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="email"
                >
                  Email
                </label>

                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="email"
                  type="email"
                  placeholder="Email "
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
              </div>

              {formik.touched.email && formik.errors.email ? (
                <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4">
                  <p className="font-bold">Error</p>
                  <p>{formik.errors.email}</p>
                </div>
              ) : null}

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="mensaje"
                >
                  Message
                </label>

                <input
                  className="shadow appearance-none border rounded w-full py-8 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="mensaje"
                  type="text"
                  placeholder="Message"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mensaje}
                />
              </div>
              {formik.touched.mensaje && formik.errors.mensaje ? (
                <div className="my-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-4">
                  <p className="font-bold">Error</p>
                  <p>{formik.errors.mensaje}</p>
                </div>
              ) : null}

              <input
                type="submit"
                className="bg-gray-800 w-full mt-5 p-2 text-white uppercas hover:cursor-pointer hover:bg-gray-900"
                value="Enviar Mensaje"
              />
              <div className="flex">
                <div className="w-7/12"> </div>
              </div>
            </form>
            </div>
             
          </div>
        
      </div>
    </div>
  );
};

export default Contactarme;
